import { IMDSButtonGroupProps } from "@/mds/components/buttons/button-group/button-group.types";
import { StyledButtonGroup } from "./button-group.styles";

export const MDSButtonGroup = ({
  children,
  orientation = "horizontal",
  ...props
}: IMDSButtonGroupProps) => {
  return (
    <StyledButtonGroup $orientation={orientation} {...props}>
      {children}
    </StyledButtonGroup>
  );
};
